import React from 'react'
import List from './List'
import FacetSection from './FacetSection'
const facetName = 'size'
const facetTitle = 'Size'
const overrideRules = {
  small: 'Small',
  medium: 'Medium',
  large: 'Large',
  oversized: 'Oversized',
}
const orderRules = ['small', 'medium', 'large', 'oversized']
export default (): React.ReactElement<React.ComponentProps<any>, any> => (
  <FacetSection
    {...{
      facetName,
      facetTitle,
    }}
    showFacet
  >
    <List
      {...{
        facetName,
        overrideRules,
        orderRules,
        show: true,
      }}
    />
  </FacetSection>
)